import React, { useState } from 'react';

import Modal from '../../../../../components/common/Modal/Modal';
import { ChordList } from '../../../../../const/ChordList';
import { CHORD } from '../../../../../const/chord';
import ChordCard from '../../../../chords/ChordCard/ChordCard';

// A row of the song's chords, shown below its other chips. Clicking any chord
// opens a modal with every chord diagram for the song, laid out like the cards
// on the chords page. The buttons live inside the song's Link, so they stop the
// click from also navigating into the song.
const ChordChips = ({ artist, chords, title }: ChordChipsTypes) => {
	const [isOpen, setIsOpen] = useState(false);

	// The diagrams for this song's chords, in order; chords without an image
	// (e.g. Asus) are simply left out of the grid.
	const chordCards = chords.flatMap((chord) => {
		const card = ChordList.find((entry) => entry.title === chord);

		return card ? [card] : [];
	});

	return (
		<>
			<div style={rowStyle}>
				{chords.map((chord) => (
					<button
						key={chord}
						onClick={(event) => {
							// Don't let the click bubble to the song Link and navigate.
							event.preventDefault();
							event.stopPropagation();
							setIsOpen(true);
						}}
						style={chipStyle}
						type="button"
					>
						{chord}
					</button>
				))}
			</div>

			{isOpen && (
				<Modal onClose={() => setIsOpen(false)} title={title} wide>
					<p style={artistStyle}>{artist}</p>
					<div style={gridStyle}>
						{chordCards.map((card) => (
							<ChordCard key={card.title} src={card.url} title={card.title} />
						))}
					</div>
				</Modal>
			)}
		</>
	);
};

const rowStyle: React.CSSProperties = {
	alignItems: 'center',
	display: 'flex',
	flexWrap: 'wrap',
	gap: 10,
	justifyContent: 'flex-start',
};

// The song title sits in the modal heading (Modal's `title`); the artist is a
// muted line just beneath it.
const artistStyle: React.CSSProperties = {
	margin: '-8px 0 12px',
	opacity: 0.7,
};

const gridStyle: React.CSSProperties = {
	display: 'grid',
	gap: 12,
	gridTemplateColumns: 'repeat(3, 1fr)',
	maxHeight: '60vh',
	overflowY: 'auto',
};

// Matches the Chip look, but as a button - reset the global button styles so it
// reads as a chip rather than a filled grey button.
const chipStyle: React.CSSProperties = {
	backgroundColor: 'rgba(128, 128, 128, 0.25)',
	border: 'none',
	borderRadius: 10,
	color: 'inherit',
	cursor: 'pointer',
	fontSize: 11,
	fontWeight: 600,
	padding: '2px 8px',
	textTransform: 'none',
	whiteSpace: 'nowrap',
};

type ChordChipsTypes = {
	artist: string;
	chords: CHORD[];
	title: string;
};

export default ChordChips;
